// client/src/pages/templates/ViewTemplate.js
import React, { useEffect, useState, useRef } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { apiFetch } from '../../api/api';
import { toast } from 'react-toastify';
import { readScope } from '../../state/scopeStorage';
import { useOrg } from "../orgs/org-context";
import '../../styles/template.css';
import '../../styles/Buttons.css';

function getActiveOrgIdSafe() {
  try {
    const s = readScope?.();
    return s?.org?.id || localStorage.getItem('activeOrgId') || localStorage.getItem('activeOrg') || null;
  } catch {
    try { return localStorage.getItem('activeOrgId') || localStorage.getItem('activeOrg') || null; } catch { return null; }
  }
}

export default function ViewTemplate() {
  const { templateId, id } = useParams();
  const tid = templateId || id;
  const navigate = useNavigate();

  const { activeOrgId } = useOrg();
  const initialOrgRef = useRef(activeOrgId);

  const [loading, setLoading] = useState(true);
  const [tpl, setTpl] = useState(null);

  // --- redirect back to list if org changes while on this page ---
  useEffect(() => {

    if (activeOrgId && initialOrgRef.current && activeOrgId !== initialOrgRef.current) {
      navigate("/templates/FieldTemplateList", { replace: true });
    }

  }, [activeOrgId, navigate]);


  // --- load template ---
  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        setLoading(true);
        const data = await apiFetch(`/templates/getTemplateById/${tid}`, { method: 'GET' });
        if (cancelled) return;
        setTpl(data);
      } catch (err) {
        console.error('ViewTemplate load error', err);
        const status = err?.response?.status;
        if (status === 401)      toast.error('Your session expired. Please log in again.');
        else if (status === 404) toast.error('Template not found.');
        else                     toast.error('Failed to load template.');
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => { cancelled = true; };
  }, [tid]);

  if (loading) {
    return (
      <div className="detail-page">
        <div className="detail-card" style={{ background: '#eef2f7' }}>Loading…</div>
      </div>
    );
  }

  if (!tpl) {
    return (
      <div className="detail-page">
        <div className="detail-card" style={{ background: '#eef2f7' }}>Template not found.</div>
      </div>
    );
  }

  const fields = Array.isArray(tpl.fields)
    ? tpl.fields.map(f => {
        if (f.type === 'image') {
          return {
            ...f,
            type: 'media',
            mediaOptions: {
              allowImage: true,
              allowVideo: false,
              maxVideoSeconds: 15
            }
          };
        }
        return f;
      })
    : [];


  return (
    <div className="detail-page">
      {/* Header with actions like your other pages (optional) */}
      <div
        className="detail-header"
        style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 12, flexWrap: 'wrap' }}
      >
        <h2 style={{ margin: 0 }}>View Project Template</h2>
        <div className="header-actions" style={{ display: 'flex', gap: 8 }}>
          <button className="btn-return" onClick={() => navigate('/templates/FieldTemplateList')}>Return</button>
          <button className="btn-green" onClick={() => navigate(`/templates/editfieldtemplate/${tpl._id}`)}>Edit</button>
        </div>
      </div>

      <div className="detail-card" style={{ background: '#eef2f7' }}>
      <div className="two-col-responsive">
        <label><b>Project Template Name</b></label>&nbsp;{tpl.name}
        &nbsp;&nbsp;&nbsp;&nbsp;
        <label><b>Description</b></label>&nbsp;{tpl.description}
      </div>

        {fields.length === 0 ? (
          <div style={{ color: 'white' }}>No fields defined.</div>
        ) : (
          <div className="table-scroll" style={{backgroundColor:"white"}}>
            <table className="compact-table">
              <thead>
                <tr >
                  <th style={{ width: 30 }}></th>
                  <th style={{ width: 30 }}>#</th>
                  <th style={{ width: 120 }}>Label</th>
                  <th style={{ width: 120 }}>Type</th>
                  <th>Options</th>
                </tr>
              </thead>
              <tbody>
                {fields.map((f, idx) => (
                  <tr key={idx} style={{ borderBottom: '1px solid #f1f5f9' }}>
                    <td style={{ padding: 8 }}>{f.label || ''}</td>
                    <td style={{ padding: 8 }}>
                      {f.type === 'select'
                        ? 'Drop-down'
                        : f.type === 'media'
                          ? 'Media'
                          : (f.type || 'text')}
                    </td>
                    <td style={{ padding: 8 }}>{f.required ? 'Yes' : 'No'}</td>
                    <td style={{ padding: 8 }}>{f.visible ? 'Yes' : 'No'}</td>
                    <td style={{ padding: 8 }}>
                      {f.type === 'select' ? (
                        Array.isArray(f.options) && f.options.length
                          ? f.options.join(', ')
                          : <span style={{ color: '#9ca3af' }}>—</span>
                      ) : f.type === 'media' ? (
                        <div style={{ fontSize: 13, color: '#334155' }}>
                          <div>Images: {f.mediaOptions?.allowImage ? 'Yes' : 'No'}</div>
                          <div>Videos: {f.mediaOptions?.allowVideo ? 'Yes' : 'No'}</div>
                          {f.mediaOptions?.allowVideo && (
                            <div>Max video: {f.mediaOptions?.maxVideoSeconds || 15}s</div>
                          )}
                        </div>
                      ) : (
                        <span style={{ color: '#9ca3af' }}>—</span>
                      )}
                    </td>

                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}
